/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import s from './BillboardNavigation.module.css';

type NavItemProps = {
  to: string;

  className?: string;
  children: React.ReactNode;
  newTab?: boolean;
  onClick?: () => void;
};

const BillboardNavItem = ({
  children,
  to,
  className,
  newTab,
  onClick,
}: NavItemProps) => {
  const { route } = useRouter();

  const isCurrent = route === to;

  return (
    <li className={cx(s.navItem, className)}>
      {isCurrent && <div className={s.navItemCurrent} />}
      {newTab ? (
        <a href={to} target="_blank" rel="noreferrer">
          {children}
        </a>
      ) : (
        <Link
          className={cx({
            [s.navItemCurrentPage]: isCurrent,
          })}
          onClick={onClick}
          href={to}
        >
          {children}
          {isCurrent ? (
            <span className={s.navItemCurrentA11yHidden}>
              {' -  Current location'}
            </span>
          ) : null}
        </Link>
      )}
    </li>
  );
};

export { BillboardNavItem };
